import logger from "./logger";
import { packageSchema, TPackage } from "./store";

const PRODUCTS_QUERY = `
query artisProducts {
  package {
    id
    name
    source: sourceBySource {
      name
      exchange { code }
    }
    products {
      id
      artis_type
      code
      description
      eod_product_dep
      logical_code
      maturity
      name
      summary_type: product_summary_type { value }
      product_type
      uom
      has_shared_cell
      geographical_region: geographicalRegionByGeographicalRegion { id }
      commodity_group: commodityGroupByCommodityGroup { id }
      commodity_parent_group: commodityGroupByCommodityGroup {
        parent: commodity_parent_group { id }
      }
      product_configs(order_by: { relative_month: asc }) {
        formula
        product
        relative_month
      }
    }
  }
}
`;

type PackagesResponse = {
  package: unknown[];
};

export async function fetchPackages(params: {
  hasuraName: string;
  token: string;
}): Promise<TPackage[]> {
  const { hasuraName, token } = params;

  if (!hasuraName || !token) {
    logger.warn("fetchPackages called without hasuraName or token", {
      hasuraName,
      hasToken: !!token,
    });
    return [];
  }

  const endpoint = `https://${hasuraName}.hasura.app/v1/graphql`;

  try {
    const res = await fetch(endpoint, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({ query: PRODUCTS_QUERY }),
    });

    if (!res.ok) {
      const body = await res.text();
      throw new Error(`HTTP ${res.status} ${res.statusText}: ${body}`);
    }

    const json = (await res.json()) as {
      data?: PackagesResponse;
      errors?: unknown;
    };

    if (json.errors) {
      throw new Error(`GraphQL errors: ${JSON.stringify(json.errors)}`);
    }

    const rawPackages = json.data?.package ?? [];
    const packages = rawPackages.map((pkg) => packageSchema.parse(pkg));

    if (packages.length === 0) {
      throw new Error("Query returned no packages");
    }

    return packages;
  } catch (error) {
    logger.error("fetchPackages failed", { error });
    throw error instanceof Error ? error : new Error(String(error));
  }
}
